// extracted by mini-css-extract-plugin
module.exports = {"chatRevampContainer":"X_ZRE","chatContainer":"_2nTBi","needHelp":"IQ0rt","online":"JDfcD","offline":"_22EkE"};